/* eslint semi:0 */
import React from 'react'
import { nodes, } from 'utils/dom'
import { render, } from 'react-dom'
import { warn, } from 'application/console'
import { MountedComponent, } from 'application/mountedComponent'


function renderMountedComponent(container, rootNode){
  const mountedComponentProps = {
    container,
    options: { rootNode, },
  }
  return render(
    <MountedComponent { ...mountedComponentProps } />,
    rootNode
  )
}

function dispatchMountAndRender(container, domNodes){
  return Array.from(domNodes, renderMountedComponent.bind(null, container));
}

function mountComponent(opts = {}){
  const { container, rootSelector, } = opts
  const domNodes = nodes(rootSelector)
  if (domNodes && domNodes.length > 0) {
    dispatchMountAndRender(container, domNodes)
    return true
  }
  warn(
    `Container '${ container.name }' can't be mounted: '${ rootSelector }' selector result is empty!`,
    { opts, container, rootSelector, domNodes, }
  )
  return false
}

export default function reduxMount(selectorComponentMap = {}){
  for (const rootSelector in selectorComponentMap) {
    const container = selectorComponentMap[rootSelector]
    if (rootSelector === "undefined") {
      warn(`mountComponent selector not defined in preRenderedSelectorsConfig: `, selectorComponentMap);
      continue;
    }
    mountComponent({ container, rootSelector, })
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/reduxMounter.js